import { Divider } from "antd";
import React, { useEffect, useState } from "react";
import { json, useLocation, useNavigate } from "react-router-dom";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import Card from "../../re-usables/card/Card";
import ListLoader from "../../re-usables/loaders/ListLoader";
import "./Order.scss";
import OrderItem from "./OrderItem";
import Swal from "sweetalert2";
import moment from "moment";

// Extend dayjs with the isBetween plugin

export default function Order() {
  const inr = <span style={{ fontFamily: "sans-serif" }}>&#x20B9;</span>;
  const [cart, setCart] = useState([]);
  const [priceBreakdown, setPriceBreakdown] = useState([]);
  const [netAmount, setNetAmount] = useState("");
  const [finalOrderVal, setFinalOrderVal] = useState("");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const creditLimit = JSON.parse(sessionStorage.getItem("creditLimit"));
  const appFlavour = process.env.REACT_APP_FLAVOUR;
  const [paymentTimeTumul, setPaymentTimeTumul] = useState([]);
  const [indent_date, setIndent_date] = useState("");
  const [paymentCondition, setPaymentCondition] = useState("");


  const get_indent_date = async () => {
    try {
      const response = await getRequest(
        urls.getDate(JSON.parse(sessionStorage.getItem("selectedBatch")).DIST_BATCH_NO)
      );
      setIndent_date(moment(response.indent_date).format("DD-MMM-YYYY"));
    } catch (error) {
      console.log(error);
    }
  }

  const payment_condition = async () => {
    try {
      const res_paybutton = await getRequest(
        urls.pay_button_condition(localStorage.getItem("userId"), indent_date, JSON.parse(sessionStorage.getItem("selectedBatch")).ROUTE_CODE)
      )
      setPaymentCondition(res_paybutton[0]);
    } catch (error) {
      console.log(error);
    }
  }

  const handlePayment = async () => {
    const now = new Date();

    // Format parts
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0"); // months start from 0
    const yyyy = now.getFullYear();

    const hh = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    const sec = String(now.getSeconds()).padStart(2, "0");

    const ms = String(now.getMilliseconds()).padStart(3, "0");

    // Final timestamp format: DDMMYYYYHHMMSSMS
    const timestamp = `${dd}${mm}${yyyy}${hh}${min}${sec}${ms}`;

    const customerCode = localStorage.getItem("userId");
    const usersCode = localStorage.getItem("agentCode");
    const routeCode = JSON.parse(sessionStorage.getItem("selectedBatch")).ROUTE_CODE;

    try {
      const payment_details = {
        gp_date: indent_date,
        customer_code: customerCode,
        users_code: usersCode,
        route_code: routeCode,
        order_id: `Ord-${customerCode}-${usersCode}-${timestamp}`,
        amount: finalOrderVal?.TOTAL,
        indent_number: paymentCondition.INDENT_NUMBER,
        pay_type: "R"
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(payment_details));
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };



  const getCartDetails = async () => {
    try {
      setLoading(true);
      let indentNumber = location.state.indentNumber;
      const response = await getRequest(urls.getCart(indentNumber));

      if (appFlavour !== "MYMUL" && appFlavour !== "VIMUL") {
        const priceBreakdown = await getRequest(
          urls.getPriceBreakdown(indentNumber)
        );
        setPriceBreakdown(priceBreakdown[0]);
      }

      if (appFlavour !== "MYMUL" && appFlavour !== "VIMUL") {
        const netAmount = await getRequest(urls.getNetAmount(indentNumber));
        setNetAmount(netAmount[0]);
      }
      const orderVal = await getRequest(urls.finalOrderValue(indentNumber));
      setCart(response[0]);
      setFinalOrderVal(orderVal[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getPaymentTime = async () => {
    try {
      const PaymentTime = await getRequest(urls.paymentTime());
      setPaymentTimeTumul(PaymentTime[0]);
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    getCartDetails();
    getPaymentTime();
    get_indent_date();
  }, []);

  useEffect(() => {
    payment_condition();
  }, [indent_date]);

  if (loading)
    return (
      <div style={{ height: "calc(100vh - 281px)", overflowY: "hidden" }}>
        <ListLoader />
      </div>
    );

  return (
    <div className="cart-items">
      <div style={{ fontWeight: 600 }}>Order Details</div>
      <div className="cart-items-scroll-area">
        {cart.length
          ? cart.map((item) => (
            <OrderItem item={item} rateCatag={location.state.rateCatag} />
          ))
          : null}
        <Divider />

        <div className={appFlavour === "MYMUL" || appFlavour === "VIMUL" ? "net-amount" : ""}>
          <div className="flex-row">
            <div className="key">Order Value</div>
            <div className="value" style={{ fontWeight: 600 }}>
              {inr} {Number(finalOrderVal?.TOTAL)?.toFixed(2)}
            </div>
          </div>
        </div>

        <div className="price-breakdown">
          {priceBreakdown.length
            ? priceBreakdown.map((item) => (
              <div className="flex-row">
                <div className="key">{item.ADD_DED_NAME}</div>
                <div className="value">
                  {inr} {Number(item?.AMT)?.toFixed(2)}
                </div>
              </div>
            ))
            : null}

          {appFlavour !== "MYMUL" && appFlavour !== "VIMUL" ? (
            <>
              <Divider />
              <div className="net-amount">
                <div className="flex-row">
                  <div className="key">Net Payable</div>
                  <div className="value">
                    {inr} {Number(netAmount?.TOTAL)?.toFixed(2)}
                  </div>
                </div>
              </div>
            </>
          ) : null}

        </div>
      </div>
      <div className="continue-btn">
        <button
          className="secondary-btn"
          onClick={() => navigate(-1, { replace: true })}
        >
          Back
        </button>

        <button
          className="primary-btn"
          onClick={() => {
            return navigate("/", { replace: true });
          }}
        >
          Continue
        </button>
        {/* {creditLimit[0]?.PAY_MODE === "C" && paymentCondition?.INV_GEN === 'Y' && paymentCondition?.PAID === 'N' ? (
          <button
            className="primary-btn"
            onClick={handlePayment}
          >
            Pay
          </button>
        ) : (
          <button
            className="primary-btn"
            onClick={() => {
              return navigate("/", { replace: true });
            }}
          >
            Continue
          </button>
        )} */}
      </div>
    </div>
  );
}
